import { z } from "zod"

export const ExpenseSchema = z.object({
  date: z.string().min(1, "Date is required"),
  amount: z
    .union([z.string(), z.number()])
    .transform(String)
    .refine(
      (value) =>
        value.trim() !== "" &&
        Number.isFinite(Number(value)) &&
        Number(value) >= 0,
      "Enter a valid amount"
    ),
  title: z.string().min(3),
  type: z.enum(["daily", "overall"]),
})
